import { getMutations } from 'entities/_config';

import { apiCall, SuccessData } from 'services/api';

export const wppMutations = getMutations({
  sendConfirmationCode: {
    action: async (payload: { phone: string }): Promise<SuccessData> => {
      return apiCall({
        path: '/whatsapp/confirmation-code',
        payload,
      });
    },

    messages: {
      suppressError: true,
      suppressSuccess: true,
    },
  },

  confirm: {
    action: async (payload: { code: string }): Promise<SuccessData> => {
      return apiCall({
        path: '/whatsapp/confirm',
        payload,
      });
    },

    messages: {
      suppressError: true,
      suppressSuccess: true,
    },
  },
});
